import { UserDimension } from "../../gql-generated/types";

export const countryDimensions = [UserDimension.Country, UserDimension.InterestCategoryId];

export const audienceDimensions = [UserDimension.AgeGender, UserDimension.Age, UserDimension.Os, ...countryDimensions];

export const funnelAnalysisDimensions = [...audienceDimensions];
